export const rootCss = {
  alignItems: "center",
  display: "flex",
  height: "32px",
  justifyContent: "center",
  margin: "8px 0 8px 8px",
  width: "32px",
};

export const iconCss = {
  width: 24,
  height: 24,
};
